<div class="container app-container">
  <ng-container *ngIf="driver">
    <h1 class="app-heading">
      <ng-container i18n="Forbidden driver">Forbidden driver</ng-container>:
      {{ driver.name }}
    </h1>
    <div class="text-center table-container">
      <table
        class="table table-borderless table-centralised"
        style="width: 100% !important"
      >
        <tbody>
          <tr>
            <th><span i18n="Name">Name</span>:</th>
            <td>{{ driver.name }}</td>
          </tr>

          <tr>
            <th><span i18n="Company">Company</span>:</th>
            <td>{{ driver.transportCompany }}</td>
          </tr>

          <tr>
            <th><span i18n="Forbidden at">Forbidden at</span>:</th>
            <td>{{ driver.forbiddenAt | date: "dd.MM.yyyy" }}</td>
          </tr>

          <tr>
            <th><span i18n="Forbidden by">Forbidden by</span>:</th>
            <td>{{ driver.addedBy.name }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div style="padding: 10px">
      <h4 i18n="Country">Reason</h4>
      <span style="white-space: pre-line">{{ driver.reason }}</span>
    </div>
  </ng-container>
  <ng-container *ngIf="!driver">
    <ng-container i18n="No driver found">No driver found</ng-container>
  </ng-container>
</div>
